// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import type { State } from '../../types';
import { debugConfigSelector } from '../../selectors/configSelectors';
import TisPlayer from './TisPlayer';

const showTisPlayerSelector = (state: State) => {
    const debugConfig = debugConfigSelector(state);
    const debug = state.environment.debug;
    return debug && debug.tisPlayer && debugConfig.tisPlayer;
};

function TisPlayerContainer() {
    const showTisPlayer = useSelector(showTisPlayerSelector);

    if(!showTisPlayer) {
        return null;
    }

    return <TisPlayer />;
}

export default TisPlayerContainer;